module.exports = __webpack_public_path__ + "static/media/atc.55312eba.png";